import { getAssistantActivity } from '../../api/assistant';

export const SET_ASSISTANT_ACTIVITY_LOADING = 'SET_ASSISTANT_ACTIVITY_LOADING';
export const SET_ASSISTANT_ACTIVITY_DATA = 'SET_ASSISTANT_ACTIVITY_DATA';
export const UPDATE_ASSISTANT_ACTIVITY_DATA = 'UPDATE_ASSISTANT_ACTIVITY_DATA';
export const REMOVE_ASSISTANT_ACTIVITY = 'REMOVE_ASSISTANT_ACTIVITY';
export const ADD_ASSISTANT_ACTIVITY_DATA = 'ADD_ASSISTANT_ACTIVITY_DATA';

export const CHANGE_ASSISTANT_VALUE = 'CHANGE_ASSISTANT_VALUE';
export const CHANGE_ASSISTANT_SEVERAL_VALUES = 'CHANGE_ASSISTANT_SEVERAL_VALUES';
export const RESET_ASSISTANT_STORE = 'RESET_ASSISTANT_STORE';

export const getActivityAction = (restaurantUuid, params, existNextLimit) => {
  return async dispatch => {
    const isInitial = params.offset === 0;
    
    dispatch(setActivityLoading({
      initial: isInitial,
      lazy: !isInitial,
    }));
    
    try {
      const response = await getAssistantActivity(restaurantUuid, params);
      
      if (isInitial) {
        dispatch(setActivityData(response.results.data));
      } else {
        dispatch(updateActivityData(response.results.data, existNextLimit));
      }
      
    } catch (error) {
      dispatch(setActivityLoading({
        initial: false,
        lazy: false,
      }));
    }
  };
};

export const setActivityLoading = payload => ({
  type: SET_ASSISTANT_ACTIVITY_LOADING,
  payload,
});

export const setActivityData = payload => ({
  type: SET_ASSISTANT_ACTIVITY_DATA,
  payload,
});

export const updateActivityData = (payload, existNextLimit) => ({
  type: UPDATE_ASSISTANT_ACTIVITY_DATA,
  payload,
  existNextLimit,
});

export const removeActivity = payload => ({
  type: REMOVE_ASSISTANT_ACTIVITY,
  payload,
});

export const addActivityData = payload => ({
  type: ADD_ASSISTANT_ACTIVITY_DATA,
  payload,
});

export const changeValue = (key, value) => ({
  type: CHANGE_ASSISTANT_VALUE,
  payload: { key, value },
});

export const changeSeveralValues = value => ({
  type: CHANGE_ASSISTANT_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_ASSISTANT_STORE,
});
